export default {
    TITLE:'Is there an {{agreementType}} for these {{type}}?',
    SUBTITLE:'Add {{type}}'
}